import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// This makes sure the backend URL is correct and does not end with "/"
const cleanBackendUrl = BACKEND_URL
    ? BACKEND_URL.replace(/\/$/, "")
    : "";

// Your API should become: https://your-backend-url.com/api
export const API = cleanBackendUrl ? `${cleanBackendUrl}/api` : "/api";

const api = axios.create({
    baseURL: API,
    timeout: 30000,
});

api.interceptors.request.use((config) => {
    console.log("API Request:", `${config.baseURL}${config.url}`);
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error("API Error:", error?.response || error);
        return Promise.reject(error);
    }
);

export default api;

export const fmtMVR = (n) =>
    `MVR ${Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
